import { Link } from 'react-router-dom';
import { heroBackground, siteStats, marqueeWords } from '@/mocks/home';
import { SITE_NAME, SITE_TAGLINE } from '@/lib/site';
import { btn } from '@/lib/ui';

const HeroSection = () => (
  <section className="relative w-full overflow-hidden bg-foreground-950">
    <div className="absolute inset-0">
      <img
        src={heroBackground}
        alt="看料社在线看料背景，营造极速超清观看氛围"
        title="看料社在线看料 - 高清不卡顿"
        className="h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/60 to-foreground-950/90" />
    </div>

    <div className="relative mx-auto flex w-full max-w-shell flex-col justify-center px-4 pb-16 pt-32 md:px-8 md:pb-20 md:pt-40">
      <span className="inline-flex w-fit items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 text-[11px] font-label text-background-100 backdrop-blur md:text-xs">
        <span className="flex h-2 w-2 items-center justify-center">
          <span className="h-2 w-2 animate-pulse rounded-full bg-accent-400" />
        </span>
        实时同步 · 全网热门现场正在更新
      </span>

      <h1 className="mt-6 max-w-4xl font-heading text-3xl font-semibold leading-tight text-background-50 md:text-5xl lg:text-[56px] lg:leading-[1.12]">
        <Link to="/" className="transition-colors hover:text-accent-200">
          {SITE_NAME}
        </Link>
        <span className="mt-3 block text-lg font-normal text-background-100 md:text-2xl">
          在线看料，高清不卡顿秒开，畅享极速超清体验
        </span>
      </h1>

      <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
        全网热门爆料视频与吃瓜现场实时同步，超清画质加载快，看料不等待，流畅到飞起。
        {SITE_TAGLINE}，把当下最热的现场一次看完。
      </p>

      <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
        <Link to="/category" className={btn('primary', 'lg')}>
          <span className="flex h-5 w-5 items-center justify-center">
            <i className="ri-play-fill text-base" />
          </span>
          立即开始观看
        </Link>
        <a href="#speed" className={btn('outline', 'lg')}>
          <span className="flex h-5 w-5 items-center justify-center">
            <i className="ri-flashlight-line text-base" />
          </span>
          了解极速播放
        </a>
      </div>

      <dl className="mt-14 grid grid-cols-2 gap-x-6 gap-y-8 border-t border-background-50/15 pt-8 md:grid-cols-4">
        {siteStats.map((stat) => (
          <div key={stat.label}>
            <dt className="text-[11px] font-label tracking-wide text-background-300 md:text-xs">
              {stat.label}
            </dt>
            <dd className="mt-2 font-heading text-2xl font-semibold text-background-50 md:text-3xl">
              {stat.value}
              <span className="ml-0.5 text-sm font-normal text-accent-300 md:text-base">
                {stat.unit}
              </span>
            </dd>
          </div>
        ))}
      </dl>
    </div>

    <div className="relative border-t border-background-50/15 bg-foreground-950/70 py-3">
      <div className="flex w-full overflow-hidden">
        <div className="marquee-track flex shrink-0 items-center gap-8 pr-8">
          {[...marqueeWords, ...marqueeWords].map((word, index) => (
            <span
              key={`${word}-${index}`}
              className="flex shrink-0 items-center gap-8 text-xs font-label text-background-200 md:text-sm"
            >
              {word}
              <i className="ri-donut-chart-fill text-[6px] text-accent-400" />
            </span>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;